import React, { useEffect } from "react";

const GoogleAd = ({ slot }) => {
  useEffect(() => {
    try {
      // 컴포넌트가 마운트된 후(렌더링 완료 후) 광고 호출
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("광고 호출 에러:", e);
    }
  }, []);

  return (
    <div style={{ width: '100%', minHeight: '100px', margin: '20px 0', textAlign: 'center' }}>
      <ins className="adsbygoogle"
           style={{ display: "block" }}
           data-ad-client="ca-pub-2633928464528168"
           data-ad-slot={slot}
           data-ad-format="auto"
           data-full-width-responsive="true"></ins>
    </div>
  );
};

export default GoogleAd;

